module.exports = __webpack_public_path__ + "img/G.124b1436.jpg";